import React from "react";
import "./Coins.css";

export default function Coins(props) {
  const coinsAlertHandler = () => {
    props.onShowAlert();
  };

  return (
    <div className="coins centeredFlex" onClick={coinsAlertHandler}>
      <img src="/images/star.svg" alt="star icon" className="starIcon" />
      <span> 0 سکه</span>
    </div>
  );
}